import { useState } from 'react';

const cards = [
  {
    tag: '热播',
    title: '《风起洛阳》第二季回归',
    desc: '原班人马集结，剧情全面升级，开播即登顶热搜',
    imgUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20dusk%20with%20warm%20lantern%20lights%2C%20traditional%20architecture%20silhouette%2C%20cinematic%20atmosphere%2C%20golden%20and%20crimson%20color%20palette%2C%20epic%20scale%2C%20high%20detail&width=800&height=560&seq=cards-01&orientation=landscape',
  },
  {
    tag: '新片',
    title: '喜剧电影《全家福》上映',
    desc: '笑中带泪的家庭故事，暑期档合家欢首选',
    imgUrl: 'https://readdy.ai/api/search-image?query=Warm%20family%20gathering%20scene%20with%20soft%20natural%20light%2C%20cozy%20home%20interior%2C%20happy%20atmosphere%2C%20golden%20hour%20tones%2C%20lifestyle%20photography%2C%20candid%20moment&width=800&height=560&seq=cards-02&orientation=landscape',
  },
  {
    tag: '推荐',
    title: '韩剧《那年冬天》口碑爆了',
    desc: '豆瓣8.9，治愈系爱情故事，每一帧都是壁纸',
    imgUrl: 'https://readdy.ai/api/search-image?query=Winter%20landscape%20with%20soft%20snowfall%2C%20warm%20coffee%20shop%20window%2C%20romantic%20atmosphere%2C%20soft%20bokeh%20lights%2C%20gentle%20pastel%20tones%2C%20cinematic%20composition&width=800&height=560&seq=cards-03&orientation=landscape',
  },
  {
    tag: '综艺',
    title: '《舞林大会》总决赛之夜',
    desc: '六强争霸，巅峰对决，收视率再创新高',
    imgUrl: 'https://readdy.ai/api/search-image?query=Dance%20performance%20stage%20with%20dramatic%20spotlight%20and%20dynamic%20movement%2C%20concert%20atmosphere%2C%20warm%20golden%20and%20deep%20purple%20contrast%2C%20artistic%20photography%2C%20energy%20and%20passion&width=800&height=560&seq=cards-04&orientation=landscape',
  },
  {
    tag: '动画',
    title: '国产动画《山海经·异兽录》',
    desc: '国风美学巅峰之作，全家老少皆宜的视觉盛宴',
    imgUrl: 'https://readdy.ai/api/search-image?query=Mythical%20Chinese%20creature%20in%20misty%20mountain%20landscape%2C%20traditional%20ink%20painting%20style%2C%20ethereal%20atmosphere%2C%20warm%20earthy%20tones%2C%20artistic%20composition%2C%20fantasy%20aesthetic&width=800&height=560&seq=cards-05&orientation=landscape',
  },
  {
    tag: '美剧',
    title: '《都市边缘》最终季上线',
    desc: '十年陪伴迎来终章，全球剧迷共同见证',
    imgUrl: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20urban%20architecture%2C%20contemplative%20mood%2C%20cinematic%20wide%20shot%2C%20end%20of%20an%20era%20atmosphere&width=800&height=560&seq=cards-06&orientation=landscape',
  },
  {
    tag: '独家',
    title: '纪录片《食在中国》第三季',
    desc: '走遍大江南北，寻找最地道的人间烟火味',
    imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20street%20food%20market%20with%20steaming%20dishes%20and%20warm%20lighting%2C%20bustling%20night%20market%20atmosphere%2C%20rich%20colors%2C%20mouth-watering%20food%20photography%2C%20cultural%20authenticity&width=800&height=560&seq=cards-07&orientation=landscape',
  },
];

function CardItem({ item }: { item: typeof cards[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col sm:flex-row">
      <div className="relative w-full sm:w-[200px] lg:w-[240px] flex-shrink-0 aspect-[16/9] sm:aspect-auto">
        {!imgError ? (
          <img
            src={item.imgUrl}
            alt={item.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-image-line text-3xl text-foreground-300"></i>
          </div>
        )}
        <div className="absolute top-2 left-2">
          <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            {item.tag}
          </span>
        </div>
      </div>
      <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
          {item.desc}
        </p>
      </div>
    </div>
  );
}

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            热播精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选的最新电视剧更新与最新电影上映，追剧党的每日必看
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {cards.map((item, idx) => (
            <CardItem key={idx} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}